



















































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeCatatanPraSedasi } from "@/store/modules/CatatanPraSedasiStore";
import CatatanPraSedasiSvc from "@/services/CatatanPraSedasi";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CatatanPraSedasiDetail from "./CatatanPraSedasiDetail.vue";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import http from "@/axios/http-common";
import moment from "moment";
import FormPrefillService from "@/services/FormPrefillService";
import HasilPenunjangSvc from "@/services/HasilPenunjang";
import {
  mapPenunjangPraAnestesi,
  PenunjangPraAnestesiHasil
} from "@/utils/labPenunjangPraAnestesi";
import {
  ANAMNESA_ITEMS,
  ASA_OPTIONS,
  PEMFIS_FIELDS,
  PENUNJANG_FIELDS
} from "@/constants/catatanPraAnestesiOptions";

const FORM_KEY = "catatan_pra_sedasi";
const PREFILL_SOURCES = ["klinis_terkini"];
const VITAL_KEYS = [
  "tinggi_badan",
  "berat_badan",
  "rr",
  "suhu",
  "nadi",
  "td_sistole",
  "td_diastole"
];

@Component({
  components: { CardModalTtd, CatatanPraSedasiDetail },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CatatanPraSedasiPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isEditing = false;
  editId: number | null = null;
  expandedId: number | null = null;
  signItemId: number | null = null;
  saving = false;
  showTtdModal = false;
  menuDate = false;
  menuTime = false;
  panels: number[] = [0];
  dokterList: any[] = [];
  loadingDokter = false;
  ttvLoading = false;
  penunjangLoading = false;
  sumberVital: string | null = null;
  sumberPenunjang: string | null = null;

  form = this.getDefaultForm();

  // ==================== OPTIONS ====================

  anamnesaItems = ANAMNESA_ITEMS;
  pemfisFields = PEMFIS_FIELDS;
  penunjangFields = PENUNJANG_FIELDS;
  asaOptions = ASA_OPTIONS;

  // ==================== LIFECYCLE ====================

  @Watch("isActive", { immediate: true })
  async onActiveChange(val: boolean) {
    if (val && this.register) {
      await this.muatDaftar();
      this.loadDokterList();
    }
  }

  @Watch("register")
  async onRegisterChange() {
    if (this.isActive && this.register) {
      await this.muatDaftar();
    }
  }

  // ==================== COMPUTED ====================

  get stateList(): any[] { return storeCatatanPraSedasi.dataList || []; }
  get stateLoading() { return storeCatatanPraSedasi.loading; }
  get currentUser() { return userModule.user; }

  canEdit(item: any) {
    if (this.readOnly) return false;
    return !!item && !item.signed_dokter_anestesi;
  }

  canDelete(item: any) {
    if (this.readOnly) return false;
    if (!item) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [{ ditandatangani: item.signed_dokter_anestesi, penandaTanganId: item.dokter_anestesi_user_id }],
      userModule.user?.id
    );
  }

  canSignDokter(item: any) {
    if (this.readOnly) return false;
    return (
      !!item &&
      !item.signed_dokter_anestesi &&
      item.dokter_anestesi_user_id === this.currentUser?.id
    );
  }

  get nrsColor() {
    const nrs = this.form.content.nyeri.skala_nrs;
    if (nrs === 0) return "green";
    if (nrs <= 3) return "light-green";
    if (nrs <= 6) return "orange";
    return "red";
  }

  // ==================== METHODS ====================

  getDefaultForm() {
    return {
      examined_date: localISODate(),
      examined_time: new Date().toTimeString().substr(0, 5),
      dokter_anestesi_user_id: null as number | null,
      content: {
        anamnesa: {
          hilang_gigi: null, masalah_mobilisasi_leher: null, leher_pendek: null,
          batuk: null, sesak_nafas: null, nyeri_dada: null,
          denyut_jantung_abnormal: null, kejang: null, merokok: null, alergi: null,
          stroke: null, pingsan: null, muntah: null, hamil: null,
          menstruasi_abnormal: null, susah_kencing: null, obesitas: null,
          hipertensi: null, gigi_palsu: null, dm: null,
          keterangan: "",
        },
        pemeriksaan_fisik: {
          tinggi_badan: null, berat_badan: null, rr: null, suhu: null,
          nadi: null, td_sistole: null, td_diastole: null,
          jalan_nafas: { catatan: "" },
          mallampati: null,
        },
        nyeri: {
          skala_nrs: 0, lokasi: "", onset: "", variasi: "",
        },
        keadaan_umum: {
          catatan: "",
        },
        penunjang: {
          hb_ht: "", natrium: "", clorida: "", kalium: "", pt_aptt: "",
          ureum: "", creatinin: "", hbsag: "", rontgen_thorax: "", ekg: "",
        },
        diagnosis: "",
        asa_klasifikasi: null as string | null,
        asa_emergency: false,
        rekomendasi: {
          sedasi: null as string | null,
          anestesi_umum: [] as string[],
          regional: [] as string[],
        },
        instruksi_pra_anestesi: "",
        keterangan: "",
      }
    };
  }

  async muatDaftar() {
    await storeCatatanPraSedasi.getByRegister(this.register);
    this.syncExpanded();
  }

  syncExpanded() {
    if (!this.expandedId) return;

    const masihAda = this.stateList.some(
      (row: any) => row.id === this.expandedId
    );
    if (!masihAda) {
      this.expandedId = null;
    }
  }

  toggleExpand(id: number) {
    this.expandedId = this.expandedId === id ? null : id;
  }

  asaLabel(item: any) {
    const content = (item && item.content) || {};
    const kelas = content.asa_klasifikasi;
    const emergency =
      content.asa_emergency === true || content.asa_klasifikasi === "E";
    const parts = [kelas && kelas !== "E" ? kelas : "", emergency ? "E" : ""];
    return parts.filter(Boolean).join(" ") || "-";
  }

  async loadDokterList() {
    this.loadingDokter = true;
    try {
      const res = await http.getData("/combo/dokter");
      this.dokterList = (res.data || []).map((d: any) => ({ id: d.user_id, nama: d.nama }));
    } catch {
      this.dokterList = [];
    }
    this.loadingDokter = false;
  }

  resetSumberPrefill() {
    this.sumberVital = null;
    this.sumberPenunjang = null;
  }

  isiKosong(nilai: unknown): boolean {
    return nilai === null || nilai === undefined || String(nilai).trim() === "";
  }

  waktuSumber(waktu?: string | null): string {
    if (!waktu) return "";
    const m = moment(String(waktu));

    return m.isValid() ? m.format("DD-MM-YYYY HH:mm") : String(waktu);
  }

  async generateVitalSign() {
    if (this.readOnly || this.ttvLoading) return;
    if (!this.rm) {
      appModule.sendErrorNotice("No. RM pasien tidak tersedia.");
      return;
    }

    this.ttvLoading = true;
    try {
      const payload = await FormPrefillService.fetchPrefill(
        String(this.rm),
        FORM_KEY,
        {
          register_id: this.register,
          unit_id: this.currentUser?.unit_id || "",
          sources: PREFILL_SOURCES
        }
      );

      const fields = (payload && payload.fields) || {};
      const target = this.form.content.pemeriksaan_fisik as Record<
        string,
        unknown
      >;
      const masuk: Array<{ key: string; path: string; nilai: unknown }> = [];

      VITAL_KEYS.forEach(key => {
        const path = `pemeriksaan_fisik.${key}`;
        if (this.isiKosong(fields[path])) return;
        masuk.push({ key, path, nilai: fields[path] });
      });

      if (!masuk.length) {
        appModule.sendErrorNotice(
          "Belum ada TTV atau antropometri pada kunjungan ini. Isi Monitor TTV terlebih dahulu."
        );
        return;
      }

      const bentrok = masuk.filter(f => !this.isiKosong(target[f.key]));
      if (
        bentrok.length > 0 &&
        !confirm(
          `${bentrok.length} kolom vital sign sudah terisi dan akan ditimpa nilai terbaru dari Monitor TTV. Lanjutkan?`
        )
      ) {
        return;
      }

      masuk.forEach(f => {
        target[f.key] = f.nilai;
      });

      const provenance = (payload && payload.provenance) || {};
      const acuan = provenance[masuk[0].path];
      const waktu = this.waktuSumber(acuan ? acuan.recorded_at : null);
      this.sumberVital = waktu
        ? `Diambil dari Monitor TTV kunjungan ini — ${waktu}`
        : "Diambil dari Monitor TTV kunjungan ini";

      appModule.NoticeDelay(
        `${masuk.length} kolom vital sign terisi dari catatan kunjungan ini.`
      );

      FormPrefillService.logAcceptance({
        form_key: FORM_KEY,
        pasien_rm: String(this.rm),
        register_id: this.register,
        unit_id: this.currentUser?.unit_id || "",
        event: "accepted",
        fields: masuk.map(f => f.path),
        provenance,
        sources: PREFILL_SOURCES
      });
    } finally {
      this.ttvLoading = false;
    }
  }

  async generatePenunjang() {
    if (this.readOnly || this.penunjangLoading) return;
    if (!this.register) {
      appModule.sendErrorNotice("Nomor register tidak diketahui.");
      return;
    }

    this.penunjangLoading = true;
    try {
      const [lab, radiologi] = await Promise.all([
        HasilPenunjangSvc.getLabByRegister(this.register).catch(() => null),
        HasilPenunjangSvc.getRadiologiByRegister(this.register).catch(() => null)
      ]);

      const labOrders = (lab && lab.data) || [];
      const radiologiOrders = (radiologi && radiologi.data) || [];

      if (!labOrders.length && !radiologiOrders.length) {
        appModule.sendErrorNotice(
          "Belum ada hasil laboratorium atau radiologi pada kunjungan ini."
        );
        return;
      }

      const hasil = mapPenunjangPraAnestesi(labOrders, radiologiOrders);
      if (!hasil.labels.length) {
        appModule.sendErrorNotice(
          "Hasil penunjang yang tersedia tidak memuat parameter pra anestesi."
        );
        return;
      }

      const target = this.form.content.penunjang as Record<string, string>;
      const keys = Object.keys(hasil.values);
      const bentrok = keys.filter(key => !this.isiKosong(target[key]));

      if (
        bentrok.length > 0 &&
        !confirm(
          `${bentrok.length} kolom pemeriksaan penunjang sudah terisi dan akan ditimpa hasil terbaru. Lanjutkan?`
        )
      ) {
        return;
      }

      keys.forEach(key => {
        target[key] = hasil.values[key];
      });

      this.sumberPenunjang = this.ringkasSumberPenunjang(hasil);
      appModule.NoticeDelay(
        `Terisi dari hasil penunjang: ${hasil.labels.join(", ")}`
      );

      FormPrefillService.logAcceptance({
        form_key: FORM_KEY,
        pasien_rm: String(this.rm),
        register_id: this.register,
        unit_id: this.currentUser?.unit_id || "",
        event: "accepted",
        fields: keys.map(key => `penunjang.${key}`),
        sources: ["lis_lab", "pacs_radiologi"]
      });
    } finally {
      this.penunjangLoading = false;
    }
  }

  ringkasSumberPenunjang(hasil: PenunjangPraAnestesiHasil): string {
    const bagian: string[] = [];

    if (hasil.sumberLab) {
      const waktu = this.waktuSumber(
        hasil.sumberLab.acc_date || hasil.sumberLab.tgl_order
      );
      const sampel = hasil.sumberLab.lis_sampel;
      const lain =
        hasil.jumlahOrderLab > 1
          ? ` (+${hasil.jumlahOrderLab - 1} sampel lain)`
          : "";
      bagian.push(
        `Lab${sampel ? " sampel " + sampel : ""}${
          waktu ? " — " + waktu : ""
        }${lain}`
      );
    }

    if (hasil.sumberRontgen) {
      const waktu = this.waktuSumber(
        hasil.sumberRontgen.reportDate || hasil.sumberRontgen.tgl
      );
      const nama = hasil.sumberRontgen.nama || "Radiologi";
      bagian.push(`${nama}${waktu ? " — " + waktu : ""}`);
    }

    return bagian.length ? `Diambil dari ${bagian.join(" · ")}` : "";
  }

  startCreate() {
    this.resetSumberPrefill();
    this.form = this.getDefaultForm();
    this.form.dokter_anestesi_user_id = this.currentUser?.id || null;
    this.editId = null;
    this.isEditing = true;
  }

  startEdit(item: any) {
    if (!item) return;
    this.resetSumberPrefill();
    this.editId = item.id;
    const content = JSON.parse(JSON.stringify(item.content || {}));

    if (content.asa_klasifikasi === "E") {
      content.asa_klasifikasi = null;
      content.asa_emergency = true;
    }

    // Parse examined_at
    let examDate = localISODate();
    let examTime = new Date().toTimeString().substr(0, 5);
    if (item.examined_at) {
      const dt = new Date(item.examined_at);
      if (!isNaN(dt.getTime())) {
        examDate = localISODate(dt);
        examTime = dt.toTimeString().substr(0, 5);
      }
    }

    this.form = {
      examined_date: examDate,
      examined_time: examTime,
      dokter_anestesi_user_id: item.dokter_anestesi_user_id,
      content: {
        ...this.getDefaultForm().content,
        ...content,
        anamnesa: { ...this.getDefaultForm().content.anamnesa, ...(content.anamnesa || {}) },
        pemeriksaan_fisik: {
          ...this.getDefaultForm().content.pemeriksaan_fisik,
          ...(content.pemeriksaan_fisik || {}),
          jalan_nafas: {
            ...this.getDefaultForm().content.pemeriksaan_fisik.jalan_nafas,
            ...((content.pemeriksaan_fisik || {}).jalan_nafas || {}),
          },
        },
        nyeri: { ...this.getDefaultForm().content.nyeri, ...(content.nyeri || {}) },
        keadaan_umum: { ...this.getDefaultForm().content.keadaan_umum, ...(content.keadaan_umum || {}) },
        penunjang: { ...this.getDefaultForm().content.penunjang, ...(content.penunjang || {}) },
        rekomendasi: { ...this.getDefaultForm().content.rekomendasi, ...(content.rekomendasi || {}) },
      },
    };

    this.isEditing = true;
  }

  cancelEdit() {
    this.resetSumberPrefill();
    this.isEditing = false;
    this.editId = null;
  }

  async save() {
    this.saving = true;

    const payload = {
      register_id: this.register,
      pasien_rm: String(this.rm),
      content: this.form.content,
      examined_at: `${this.form.examined_date} ${this.form.examined_time}:00`,
      dokter_anestesi_user_id: this.form.dokter_anestesi_user_id,
    };

    try {
      if (this.editId) {
        await CatatanPraSedasiSvc.update(this.editId, payload);
      } else {
        await CatatanPraSedasiSvc.create(payload);
      }
      this.isEditing = false;
      this.editId = null;
      await this.muatDaftar();
    } catch {
      // error handled by service
    }

    this.saving = false;
  }

  openTtd(item: any) {
    if (!item) return;
    this.signItemId = item.id;
    this.showTtdModal = true;
  }

  async doSign(password: string) {
    if (!this.signItemId) return;

    try {
      await CatatanPraSedasiSvc.signDokter(this.signItemId, { password });
      this.signItemId = null;
      await this.muatDaftar();
    } catch (err) {
      const e = err as any;
      if (e && e.response && e.response.data && e.response.data.message) {
        appModule.addMsgTtd(e.response.data.message);
      }
    }
  }

  async remove(item: any) {
    if (!item) return;
    if (!this.canDelete(item)) return;
    if (!confirm("Yakin ingin menghapus Catatan Pra Anestesi/Sedasi ini?")) return;

    try {
      await CatatanPraSedasiSvc.destroy(item.id);
      await this.muatDaftar();
    } catch {
      // error handled by service
    }
  }

  cetakPdf(item: any) {
    if (!item) return;
    CatatanPraSedasiSvc.print(item.id);
  }

  formatDateTime(val: string) {
    if (!val) return "-";
    const d = new Date(val);
    if (isNaN(d.getTime())) return val;
    return d.toLocaleString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  }
}
